import React from 'react';
import { MapPin, Phone, Mail, Globe } from 'lucide-react';
import { brandInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div>
            <div className="bg-white p-3 rounded-lg inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_brochure-landing-1/artifacts/a26195gs_AKIWA%20-%20Logo%20website.jpg" 
                alt="AKIWA - Experience The Edge" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Premium technology solutions for professional environments and modern homes.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('hero')} className="text-gray-400 hover:text-white transition-colors text-sm">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="text-gray-400 hover:text-white transition-colors text-sm">
                  Products
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('inquiry')} className="text-gray-400 hover:text-white transition-colors text-sm">
                  Request Quote
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-gray-400 hover:text-white transition-colors text-sm">
                  Testimonials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-white transition-colors text-sm">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h4 className="font-bold text-lg mb-4">Our Products</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('category-pro')} className="text-gray-400 hover:text-white transition-colors text-sm">
                  AKIWA PRO
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('category-home')} className="text-gray-400 hover:text-white transition-colors text-sm">
                  AKIWA HOME
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('category-security')} className="text-gray-400 hover:text-white transition-colors text-sm">
                  AKIWA SECURITY
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="flex-shrink-0 mt-1 text-gray-400" size={16} />
                <span className="text-gray-400 text-sm">{brandInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="flex-shrink-0 text-gray-400" size={16} />
                <a href={`tel:${brandInfo.phone}`} className="text-gray-400 hover:text-white transition-colors text-sm">
                  {brandInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="flex-shrink-0 text-gray-400" size={16} />
                <a href={`mailto:${brandInfo.email}`} className="text-gray-400 hover:text-white transition-colors text-sm">
                  {brandInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Globe className="flex-shrink-0 text-gray-400" size={16} />
                <a href={`https://${brandInfo.website}`} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  {brandInfo.website}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} {brandInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
